import { Component, inject } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { GlobalLoadingBannerService } from './global-loading-banner.service';

@Component({
  selector: 'app-global-loading-banner',
  standalone: true,
  imports: [ProgressSpinnerModule],
  templateUrl: './global-loading-banner.component.html',
  styleUrl: './global-loading-banner.component.css'
})
export class GlobalLoadingBannerComponent {
  readonly banner = inject(GlobalLoadingBannerService);
}
